import { Component } from '@angular/core';
import { FeatureFlagService } from '../../../core/services/feature-flag.service';

@Component({
    selector: 'app-website-terms-conditions',
    templateUrl: './website-terms-conditions.component.html',
    styleUrls: ['./website-terms-conditions.component.scss'],
    standalone: false
})
export class WebsiteTermsConditionsComponent {
  constructor(private readonly featureFlagService: FeatureFlagService) {}

  /**
   * P2P-28 · F0.3 — consolidation-first: P2P adds sections, not pages. The Notes (P2P) and
   * wallet / withdrawal-limits (PM-03) sections ship dark behind the P2P-29 flag with
   * clearly-marked DRAFT copy until Legal delivers the final text (open items F-07, PM-03).
   *
   * NOTE (open item — confirm with Legal/Nicholas): this places the consolidated sections
   * on the platform-wide "Website Terms of Use". If the consolidated /terms-conditions is a
   * different/merged page, the sections move with a one-line template change.
   */
  get notesEnabled(): boolean {
    return this.featureFlagService.notesEnabled;
  }
}
